import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import FILE_API_URL from 'utils/FileApiUrl'

export const getS3URL =
	(key, argObject = {}) =>
	(dispatch, getState) => {
		dispatch({
			type: ActionType.S3_MANAGER.POST_REQUEST,
			...argObject,
		})

		return Auth.currentSession()
			.then((session) => {
				const headerValue = `Bearer ${session.idToken.jwtToken}`

				return fetch(`${FILE_API_URL}`, {
					cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
					headers: {
						'content-type': 'application/json',
						authorization: headerValue,
					},
					method: 'POST', // *GET, POST, PUT, DELETE, etc.
					body: JSON.stringify({ key }),
					mode: 'cors', // no-cors, cors, *same-origin
					redirect: 'follow', // manual, *follow, error
					referrer: 'no-referrer', // *client, no-referrer
				})
					.then((res) =>
						res.json().then((data) => {
							if (!res.ok) {
								return { notOk: true, ...data }
							}
							return data
						}),
					)
					.then((payload) =>
						payload && payload.notOk
							? dispatch({
									type: ActionType.S3_MANAGER.POST_FAILURE,
									payload,
									notOk: true,
									...argObject,
							  })
							: dispatch({
									type: ActionType.S3_MANAGER.POST_SUCCESS,
									payload,
									...argObject,
							  }),
					)
					.catch((error) =>
						dispatch({
							type: ActionType.S3_MANAGER.POST_FAILURE,
							payload: error,
							...argObject,
						}),
					)
			})
			.catch((err) => {
				console.log(err)
			})
	}

// TODO: figure out how to handle errors here
export const uploadToS3 =
	(key, filedata, argObject = {}) =>
	(dispatch, getState) =>
		new Promise((resolve, reject) => {
			dispatch({
				type: ActionType.S3_MANAGER.POST_REQUEST,
				...argObject,
			})

			const upload = function (requestUrl, data) {
				console.log('data: ', data)
				let options = {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
					mode: 'cors',
					method: 'PUT',
				}
				if (filedata !== 'folder') {
					options.body = data
					options.headers['Content-Type'] = data.type
				}

				return fetch(requestUrl, options)
			}

			return Auth.currentSession()
				.then((session) => {
					const headerValue = `Bearer ${session.idToken.jwtToken}`

					return fetch(`${FILE_API_URL}`, {
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						headers: {
							'content-type': 'application/json',
							authorization: headerValue,
						},
						method: 'POST', // *GET, POST, PUT, DELETE, etc.
						body: JSON.stringify({ key, type: filedata.type }),
						mode: 'cors', // no-cors, cors, *same-origin
						redirect: 'follow', // manual, *follow, error
						referrer: 'no-referrer', // *client, no-referrer
					})
						.then((res) =>
							res.json().then((data) => {
								if (!res.ok) {
									return { notOk: true, ...data }
								}
								return data
							}),
						)
						.then((payload) => {
							console.log('payload: ', payload)
							if (payload?.notOk) {
								dispatch({
									type: ActionType.S3_MANAGER.POST_FAILURE,
									payload,
									...argObject,
								})
								reject(payload)
								return
							}

							upload(payload.url, filedata).then((uploadPayload) => {
								dispatch({
									type: ActionType.S3_MANAGER.POST_SUCCESS,
									payload: uploadPayload,
									...argObject,
								})
								resolve(uploadPayload)
							})
						})
						.catch((error) =>
							dispatch({
								type: ActionType.S3_MANAGER.POST_FAILURE,
								payload: error,
								...argObject,
							}),
						)
				})
				.catch((err) => {
					console.log(err)
				})
		})

export const listFiles =
	(path = '', argObject = {}) =>
	(dispatch, getState) =>
		new Promise((resolve, reject) => {
			dispatch({
				type: ActionType.S3_MANAGER.LIST_REQUEST,
				...argObject,
			})

			return Auth.currentSession()
				.then((session) => {
					const headerValue = `Bearer ${session.idToken.jwtToken}`

					return fetch(`${FILE_API_URL}/list?path=${path}`, {
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						headers: {
							'content-type': 'application/json',
							authorization: headerValue,
						},
						method: 'GET', // *GET, POST, PUT, DELETE, etc.

						mode: 'cors', // no-cors, cors, *same-origin
						redirect: 'follow', // manual, *follow, error
						referrer: 'no-referrer', // *client, no-referrer
					})
						.then((res) =>
							res.json().then((data) => {
								if (!res.ok) {
									return { notOk: true, ...data }
								}
								return data
							}),
						)
						.then((payload) => {
							if (payload?.notOk) {
								dispatch({
									type: ActionType.Data.LIST_FAILURE,
									entityType: 'file',
									payload,
									notOk: true,
									...argObject,
								})
								reject(payload)
								return
							}
							dispatch({
								type: ActionType.S3_MANAGER.LIST_SUCCESS,
								payload,
								...argObject,
							})
							resolve(payload)
						})
						.catch((error) =>
							dispatch({
								type: ActionType.Data.LIST_FAILURE,
								entityType: 'file',
								payload: error,
								...argObject,
							}),
						)
				})
				.catch((err) => {
					console.log(err)
				})
		})

export const deleteFiles =
	(keys, argObject = {}) =>
	(dispatch, getState) => {
		dispatch({
			type: ActionType.S3_MANAGER.DELETE_REQUEST,
			...argObject,
		})

		return Auth.currentSession()
			.then((session) => {
				const headerValue = `Bearer ${session.idToken.jwtToken}`

				return fetch(`${FILE_API_URL}`, {
					cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
					headers: {
						'content-type': 'application/json',
						authorization: headerValue,
					},
					method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
					body: JSON.stringify({ keys }),
					mode: 'cors', // no-cors, cors, *same-origin
					redirect: 'follow', // manual, *follow, error
					referrer: 'no-referrer', // *client, no-referrer
				})
					.then((res) =>
						res.json().then((data) => {
							if (!res.ok) {
								return { notOk: true, ...data }
							}
							return data
						}),
					)
					.then((payload) =>
						payload && payload.notOk
							? dispatch({
									type: ActionType.Data.DELETE_FAILURE,
									payload,
									entityType: 'file',
									notOk: true,
									...argObject,
							  })
							: dispatch({
									type: ActionType.S3_MANAGER.DELETE_SUCCESS,
									payload,
									...argObject,
							  }),
					)
					.catch((error) =>
						dispatch({
							type: ActionType.Data.DELETE_FAILURE,
							payload: error,
							entityType: 'file',
							...argObject,
						}),
					)
			})
			.catch((err) => {
				console.log(err)
			})
	}
export const moveFiles =
	(key, copySource, argObject = {}) =>
	(dispatch, getState) => {
		dispatch({
			type: ActionType.S3_MANAGER.MOVE_REQUEST,
			...argObject,
		})

		return Auth.currentSession()
			.then((session) => {
				const headerValue = `Bearer ${session.idToken.jwtToken}`

				return fetch(`${FILE_API_URL}/move`, {
					cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
					headers: {
						'content-type': 'application/json',
						authorization: headerValue,
					},
					method: 'PUT', // *GET, POST, PUT, DELETE, etc.
					body: JSON.stringify({
						copySource,
						key,
					}),
					mode: 'cors', // no-cors, cors, *same-origin
					redirect: 'follow', // manual, *follow, error
					referrer: 'no-referrer', // *client, no-referrer
				})
					.then((res) =>
						res.json().then((data) => {
							if (!res.ok) {
								return { notOk: true, ...data }
							}
							return data
						}),
					)
					.then((payload) =>
						payload && payload.notOk
							? dispatch({
									type: ActionType.Data.UPDATE_FAILURE,
									payload,
									entityType: 'file',
									notOk: true,
									...argObject,
							  })
							: dispatch({
									type: ActionType.S3_MANAGER.MOVE_SUCCESS,
									payload,
									...argObject,
							  }),
					)
					.catch((error) =>
						dispatch({
							type: ActionType.Data.UPDATE_FAILURE,
							payload: error,
							...argObject,
						}),
					)
			})
			.catch((err) => {
				console.log(err)
			})
	}
export const deleteFolder =
	(key, argObject = {}) =>
	(dispatch, getState) => {
		dispatch({
			type: ActionType.S3_MANAGER.DELETE_FOLDER_REQUEST,
			...argObject,
		})

		return Auth.currentSession()
			.then((session) => {
				const headerValue = `Bearer ${session.idToken.jwtToken}`

				return fetch(`${FILE_API_URL}/delete-folder`, {
					cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
					headers: {
						'content-type': 'application/json',
						authorization: headerValue,
					},
					method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
					body: JSON.stringify({
						key,
					}),
					mode: 'cors', // no-cors, cors, *same-origin
					redirect: 'follow', // manual, *follow, error
					referrer: 'no-referrer', // *client, no-referrer
				})
					.then((res) =>
						res.json().then((data) => {
							if (!res.ok) {
								return { notOk: true, ...data }
							}
							return data
						}),
					)
					.then((payload) =>
						payload && payload.notOk
							? dispatch({
									type: ActionType.Data.DELETE_FAILURE,
									payload,
									entityType: 'folder',
									notOk: true,
									...argObject,
							  })
							: dispatch({
									type: ActionType.S3_MANAGER.DELETE_FOLDER_SUCCESS,
									payload,
									...argObject,
							  }),
					)
					.catch((error) =>
						dispatch({
							type: ActionType.Data.DELETE_FAILURE,
							payload: error,
							entityType: 'folder',
							...argObject,
						}),
					)
			})
			.catch((err) => {
				console.log(err)
			})
	}
